import React, {Component, Fragment} from "react";
import BasicSelect from "./BasicSelect";
import CustomCheckbox from "./CheckboxField";
import {Button, Col, Row} from "reactstrap";

interface IState {
  value: string;
  type: string;
  required: boolean;
}

interface ValueChanged {
  value: string | number;
  element: "type" | "value"
}

class FireRatingFilter extends Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.reset = this.reset.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  public state = {
    type: "",
    value: "",
    required: false
  }

  public reset() {
    const {handleValueChanged} = this.props;
    this.setState({
      type: "",
      value: ""
    }, () => {
      if (handleValueChanged) {
        handleValueChanged([this.state.type, this.state.value.toString()])
      }
    })
  }

  public handleInputChange(e: ValueChanged) {
    const {handleValueChanged} = this.props;
    this.setState({
      ...this.state,
      [e.element]: e.value
    }, () => {
      if (handleValueChanged && this.state.type && this.state.value) {
        handleValueChanged([this.state.type, this.state.value.toString()])
      }
    });
  }

  public render() {
    return (
      <Fragment>
        <Row>
          <Col>
            <p>Fire Rating</p>
          </Col>
          <Col className="text-right">
            <Button size="sm" outline onClick={this.reset}>Reset</Button>
          </Col>
        </Row>
        <BasicSelect
          fieldName="wallType"
          options={[{label: "Boundary Wall", value: "Boundary Wall"}, {
            label: "Non-Boundary Wall",
            value: "Non-Boundary Wall"
          }]}
          value={this.state.type}
          handleSelect={(value: string) => this.handleInputChange({element: "type", value})}
        />
        <br/>
        <CustomCheckbox
          fieldId="fireRatingValue"
          fieldName="fireRatingValue"
          checkedOption={this.state.value}
          handleValueChange={(value: string[]) => this.handleInputChange({element: "value", value: value[0]})}
          options={[
            {
              "label": "60",
              "value": "60"
            },
            {
              "label": "90",
              "value": "90"
            },
            {
              "label": "120",
              "value": "120"
            }
          ]}
        />
      </Fragment>
    )
  }
}

export default FireRatingFilter;